


































































































import Vue from 'vue';
import BlobList from '../components/BlobList.vue';
import Scheduled from '../components/Scheduled.vue';
import FailedIds from '../components/FailedIds.vue';
import { fetchling, cancelableFetch } from '../hooks';
import { reactive, watch, onMounted, onUnmounted } from '@vue/composition-api';
import { eventBus } from '../main';

export default {
  components: { BlobList, Scheduled, FailedIds },
  setup(props: any, { root }: any) {
    const state = reactive({
      blobList: {
        data: [],
        loading: true,
      },
      wrongDatasource: false,
      client: '',
      resourceType: '',
      email: '',
      scheduled: {
        data: [],
        loading: true,
      },
      messages: {
        failedIds: [],
        loading: true,
      },
      webProcessorsTypes: [],
    });

    const toCamel = (snake: string) => {
      return snake.replace(/([-_][a-z])/gi, $1 => {
        return $1
          .toUpperCase()
          .replace('-', '')
          .replace('_', '');
      });
    };

    function processFailedMessages(failedMessages: any, client: string) {
      return failedMessages
        .filter(({ id }: any) => id.client === client)
        .map((failedMessage: any) => ({
          ...failedMessage,
          id: `${failedMessage.id.client} - ${failedMessage.id.dataSource}`,
        }));
    }

    function getDataTubesSchedule() {
      state.scheduled = {
        loading: true,
        data: [],
      };
      cancelableFetch(root, 'changeRoot', () =>
        fetchling('get-data-tubes-schedule', state.client),
      )
        .then(scheduled => (state.scheduled = scheduled))
        .catch(() => {
          state.scheduled = {
            data: [],
            loading: false,
          };
        });
    }

    function getBlobList() {
      state.blobList = {
        data: [],
        loading: true,
      };
      state.wrongDatasource = false;

      cancelableFetch(root, 'changeRoot', () =>
        fetchling('list-blobs', state.resourceType),
      )
        .then(blobList => {
          state.blobList = blobList;
          state.wrongDatasource = false;
        })
        .catch(() => {
          state.blobList = {
            data: [],
            loading: false,
          };
          state.wrongDatasource = true;
        });
    }

    function getCancelableMessages() {
      state.messages = {
        failedIds: [],
        loading: true,
      };

      cancelableFetch(root, 'changeRoot', () =>
        fetchling('messages', state.client),
      )
        .then(
          ({ data, loading }: { data: any[]; loading: boolean }) =>
            (state.messages = {
              failedIds: processFailedMessages(data, state.client),
              loading,
            }),
        )
        .catch(() => (state.messages = { failedIds: [], loading: false }));
    }

    const customHeaders = [
      {
        text: 'Ingress Connectors',
        value: 'endpoint',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Scheduled',
        value: 'scheduledMessages',
        width: '110px',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Files Incoming',
        value: 'retMessages',
        width: '110px',
        align: 'center',
        sortable: false,
      },
    ];

    const customFailedIdsHeaders = [
      {
        title: 'Tube',
        width: '180px',
        value: 'dataSource',
        align: 'left',
      },
    ];

    onMounted(() => {
      eventBus.$on('getBlobList', getBlobList);
      eventBus.$on('schedule', getDataTubesSchedule);
      eventBus.$on('failedMessages', getCancelableMessages);
    });

    onUnmounted(() => {
      eventBus.$off('schedule');
      root.$off('changeRoot');
    });

    watch(
      () => root.$route,
      async () => {
        const { resource } = root.$route.params;
        state.client = resource;
        state.resourceType = toCamel(resource);

        root.$emit('changeRoot');

        getDataTubesSchedule();
        getCancelableMessages();
        getBlobList();
      },
    );

    watch(
      () => root.$store.state.webProcessorsTypes,
      () => (state.webProcessorsTypes = root.$store.state.webProcessorsTypes),
    );

    return {
      state,
      customHeaders,
      customFailedIdsHeaders,
      getBlobList,
      getCancelableMessages,
    };
  },
};
